module.exports = __webpack_public_path__ + "5672cce0f27c443f38b2ff0206b44ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/reporting-graphics.png
// module id = 2304
// module chunks = 1